import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DocumentQuoteConfigPartial } from 'src/app/domain/entities/partials/documents/quote/document-quote-config.partial';
import { RaCurrencyPipe } from 'src/app/shared/pipes/ra-currency.pipe';
import { UnitOfMeasurementFormatPipe } from 'src/app/shared/pipes/unit-of-measurement-format.pipe';

@Component({
    selector: 'quote',
    templateUrl: 'quote.component.html',
    styleUrls: ['quote.component.scss', '../../document-preview.scss'],
    imports: [CommonModule, TranslatePipe, UnitOfMeasurementFormatPipe, RaCurrencyPipe],
})
export class QuoteComponent {
    public quoteConfig = input.required<DocumentQuoteConfigPartial>();

    /** Moeda do documento (ISO 4217). Ausente => fallback BRL. Ver `RaCurrencyPipe`. */
    public currencyCode = input<string | null | undefined>();

    /** Locale do documento — define separadores e posição do símbolo. */
    public locale = input<string | null | undefined>();

    /**
     * Formata um desconto percentual (ex.: `5` => `5,00%`). O `value` do desconto
     * em modo `percentage` é o PERCENTUAL bruto, não um valor monetário — ver
     * `DocumentQuoteConfigPartial` e o contrato `currency-and-money.md` §5. Usa
     * `Intl.NumberFormat` (não o pipe `number` do Angular) para não depender de
     * locales registrados, espelhando a estratégia do `RaCurrencyPipe`. Mantém 2
     * casas decimais para ficar consistente com o app mobile (`formatPercentage`).
     */
    public formatPercent(value: number | null | undefined, locale?: string | null): string {
        const amount = typeof value === 'number' && Number.isFinite(value) ? value : 0;
        const formatted = new Intl.NumberFormat(locale || 'pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
        return `${formatted}%`;
    }
}
